module.exports = __webpack_public_path__ + "static/media/kitty-love-2.0f2ae613.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/kitty-love-2.svg
// module id = 129
// module chunks = 0